interface PasswordStrengthBarProps {
  passwordStrength?: string | null;
}

const PasswordStrengthBar = ({
  passwordStrength,
}: Readonly<PasswordStrengthBarProps>) => {
  if (!passwordStrength) {
    return null;
  }

  const getBody = (className: string) => {
    return (
      <div className="password-strength-bar">
        <p className={`password-strength-bar-text ${className}`}>
          {passwordStrength}
        </p>
        <div className={`bar ${className}`} />
      </div>
    );
  };

  switch (passwordStrength) {
    case "Too weak":
      return getBody("too-weak");
    case "Weak":
      return getBody("weak");
    case "Medium":
    case "Okay":
      return getBody("medium");
    case "Strong":
      return getBody("strong");
    default:
      return null;
  }
};

export default PasswordStrengthBar;
